<script lang="ts">
	interface Props {
		className?: string;
	}

	let { className = '' }: Props = $props();
</script>

<div class={className}>
	<svg
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		viewBox="0 0 32 32"
		xml:space="preserve"
		fill="currentColor"
	>
		<path
			fill="currentColor"
			d="M17,15v-1c0-0.552-0.448-1-1-1h-6c-0.552,0-1,0.448-1,1v1c0,0.552,0.448,1,1,1h6 C16.552,16,17,15.552,17,15z M10,14h6v1h-6V14z M13,11v-1c0-0.552-0.448-1-1-1H6c-0.552,0-1,0.448-1,1v1c0,0.552,0.448,1,1,1h6 C12.552,12,13,11.552,13,11z M6,10h6v1H6V10z M23,19v-1c0-0.552-0.448-1-1-1h-6c-0.552,0-1,0.448-1,1v1c0,0.552,0.448,1,1,1h6 C22.552,20,23,19.552,23,19z M16,18h6v1h-6V18z M27,5h-2V3.5C25,3.224,24.776,3,24.5,3S24,3.224,24,3.5V5h-1V3.5 C23,3.224,22.776,3,22.5,3S22,3.224,22,3.5V5H10V3.5C10,3.224,9.776,3,9.5,3S9,3.224,9,3.5V5H8V3.5C8,3.224,7.776,3,7.5,3 S7,3.224,7,3.5V5H5C3.343,5,2,6.343,2,8v17c0,1.657,1.343,3,3,3h22c1.657,0,3-1.343,3-3V8C30,6.343,28.657,5,27,5z M29,25 c0,1.105-0.895,2-2,2H5c-1.105,0-2-0.895-2-2V8c0-1.105,0.895-2,2-2h22c1.105,0,2,0.895,2,2V25z M26,21h-3c-0.552,0-1,0.448-1,1v1 c0,0.552,0.448,1,1,1h3c0.552,0,1-0.448,1-1v-1C27,21.448,26.552,21,26,21z M26,23h-3v-1h3V23z"
		></path>
	</svg>
</div>
